import React, { useState } from "react";
import ajaxSuppliers from "../../util/remote/ajaxSuppliers";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Toast } from "bootstrap";

function CreateSuppliers(props) {
  // Form states
  const [bussName, setBussName] = useState("");
  const [bussContact, setBussContact] = useState("");
  const [bussEmail, setBussEmail] = useState("");
  const [bussTIN, setBussTIN] = useState("");
  const [bussLocation, setBussLocation] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [personContact, setPersonContact] = useState("");

  // Partners state
  const [partners, setPartners] = useState([]);

  // Partner table handlers
  const handlePartnerChange = (index, field, value) => {
    const updated = [...partners];
    updated[index][field] = value;
    setPartners(updated);
  };

  const handleAddPartner = () => {
    if (partners.length > 0) {
      const last = partners[partners.length - 1];
      if (!last.partner_name || !last.partner_contact) {
        toast.error(
          "Please complete the current partner row before adding a new one."
        );
        return;
      }
    }
    setPartners([...partners, { partner_name: "", partner_contact: "" }]);
  };

  const handleDeletePartner = (index) => {
    const updated = [...partners];
    updated.splice(index, 1);
    setPartners(updated);
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate partners
    for (let i = 0; i < partners.length; i++) {
      const p = partners[i];
      if (!p.partner_name || !p.partner_contact) {
        toast.error(`Please complete all details for partner ${i + 1}`);
        return;
      }
    }

    const data = {
      buss_name: bussName,
      buss_contact: bussContact,
      buss_email: bussEmail,
      buss_tin: bussTIN,
      buss_location: bussLocation,
      contact_person: contactPerson,
      person_contact: personContact,
      partners: partners,
    };

    const response = await ajaxSuppliers.createSupplier(data);

    if (response.status === "OK") {
      props.func?.();
      toast.success(response.message);
      // Reset form
      setBussName("");
      setBussContact("");
      setBussEmail("");
      setBussTIN("");
      setBussLocation("");
      setContactPerson("");
      setPersonContact("");
      setPartners([]);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <div className="col-lg-12 col-md-12">
      <div className="card custom-card">
        <div className="card-body">
          <h6 className="main-content-label mb-1">Create Supplier</h6>
          <Toaster />
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              {/* Left Column */}
              <div className="col-md-6">
                <div className="form-group">
                  <p className="mg-b-10">Business Name</p>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Business Name"
                    value={bussName}
                    onChange={(e) => setBussName(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <p className="mg-b-10">Business Contact</p>
                  <PhoneInput
                    country={"ug"}
                    value={bussContact}
                    onChange={(phone) => setBussContact("+" + phone)}
                    containerStyle={{ width: "100%" }}
                    inputStyle={{
                      width: "100%",
                      fontSize: "1rem",
                      border: "1px solid #ced4da",
                      borderRadius: "0.25rem",
                    }}
                    enableSearch
                  />
                </div>

                <div className="form-group">
                  <p className="mg-b-10">Business Email</p>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Business Email"
                    value={bussEmail}
                    onChange={(e) => setBussEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <p className="mg-b-10">Business TIN</p>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Business TIN"
                    value={bussTIN}
                    onChange={(e) => setBussTIN(e.target.value)}
                    required
                  />
                </div>
              </div>

              {/* Right Column */}
              <div className="col-md-6">
                <div className="form-group">
                  <p className="mg-b-10">Business Location</p>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Business Location"
                    value={bussLocation}
                    onChange={(e) => setBussLocation(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <p className="mg-b-10">Contact Person</p>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Contact Person"
                    value={contactPerson}
                    onChange={(e) => setContactPerson(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <p className="mg-b-10">Person Contact</p>
                  <PhoneInput
                    country={"ug"}
                    value={personContact}
                    onChange={(phone) => setPersonContact("+" + phone)}
                    containerStyle={{ width: "100%" }}
                    inputStyle={{
                      width: "100%",
                      fontSize: "1rem",
                      border: "1px solid #ced4da",
                      borderRadius: "0.25rem",
                    }}
                    enableSearch
                  />
                </div>
              </div>

              {/* Partners Table */}
              <div className="mb-4 col-md-12">
                <h6>Business Partners</h6>
                <table className="table table-bordered table-hover text-nowrap mg-b-0">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Partner Name</th>
                      <th>Partner Contact</th>
                      <th>Operations</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partners.map((partner, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            value={partner.partner_name}
                            onChange={(e) =>
                              handlePartnerChange(
                                index,
                                "partner_name",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td>
                          <PhoneInput
                            country={"ug"}
                            value={partner.partner_contact}
                            onChange={(phone) =>
                              handlePartnerChange(
                                index,
                                "partner_contact",
                                "+" + phone
                              )
                            }
                            containerStyle={{ width: "100%" }}
                            inputStyle={{
                              width: "100%",
                              fontSize: "1rem",
                              border: "1px solid #ced4da",
                              borderRadius: "0.25rem",
                            }}
                            enableSearch
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDeletePartner(index)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={4}>
                        <button
                          type="button"
                          onClick={handleAddPartner}
                          className="btn btn-secondary btn-sm"
                        >
                          Add Partner
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Submit Button */}
              <div className="col-md-12 mt-3">
                <button
                  type="submit"
                  className="btn ripple btn-primary btn-rounded col-md-12"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateSuppliers;
